import React, { useRef, useState } from 'react'
import styles from './contact.module.scss'
import emailjs from 'emailjs-com';
import { HiOutlineMailOpen } from "react-icons/hi"
import { GrInstagram } from "react-icons/gr"
import { FiArrowUpRight, FiArrowRight } from "react-icons/fi"
import { IoLogoWhatsapp } from "react-icons/io"
import { TbSend } from "react-icons/tb"
import { BsChat } from "react-icons/bs"
import classNames from 'classnames';
import SectionBorder from 'components/Section-Border';

export default function Contact() {

    const [popup, setPopup] = useState(false);

    const openPopUp = () => {
        setPopup(true);
        setTimeout(() => {
            setPopup(false);
        }, 3000); 
    };
    
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs
        .sendForm("service_kxhbvq5", "template_wrs72vf", form.current, "rjFNohx6H_mc0A9Mk")
        .then((result) => {
          console.log(result.text);
          setPopup(true);
          setTimeout(() => {
            setPopup(false);
          }, 3000);
          e.target.reset();
        })
        .catch((error) => {
          console.log(error.text);
        });
    };

    return (
        <section className={styles.contact_section} id="contact">
            <div className={classNames(styles.container_titles, 'scroll_top')}>
                <span>Get In Touch</span>
                <h2>Contact Me</h2>
            </div>
            <div className={styles.contact_container} >
                <div className={styles.contact_options}>
                    <h3 className='scroll_top' >Talk to me <BsChat style={{color: '#4d4d4d', marginLeft: '0.2em'}} /> </h3>
                    <article className={classNames(styles.contact_option, 'scroll_scale')}>
                        <HiOutlineMailOpen className={styles.option_icon} style={{color: '#4d4d4d'}} />
                        <h4>Email</h4>
                        <h5>marcospaulomaio2607@gmail.com</h5>
                        <a href='mailto:marcospaulomaio2607@gmail.com' target="_blank" rel="noreferrer">Send a message <FiArrowRight className={classNames(styles.icon_send, styles.i )} /></a>
                    </article>

                    <article className={classNames(styles.contact_option, 'scroll_scale')}>
                        <GrInstagram className={styles.option_icon} style={{color: '#4d4d4d'}} />
                        <h4>Instagram</h4>
                        <h5>@marcos_maiio</h5>
                        <a href="https://www.instagram.com/marcos_maiio" target="_blank" rel="noreferrer">Send a message <FiArrowRight className={classNames(styles.icon_send, styles.i )} /></a>
                    </article>

                    <article className={classNames(styles.contact_option, 'scroll_scale')}>
                        <IoLogoWhatsapp className={styles.option_icon} style={{color: '#4d4d4d'}} />
                        <h4>Whatsapp</h4>
                        <h5>55+ 21965399177</h5>
                        <a href='https://api.whatsapp.com/send?phone=5521965399177&text=Olá Marcos tudo bem ? podemos conversar ?' target="_blank" rel="noreferrer" >Send a message <FiArrowRight className={classNames(styles.icon_send, styles.i )} /></a> 
                    </article>
                    </div>
                    <div className={styles.contact_form}>
                    <h3 className='scroll_top' >Write me a message <TbSend style={{color: '#4d4d4d', marginLeft: '0.2em'}} /> </h3>
                        <form ref={form} onSubmit={sendEmail} className='scroll_scale' >
                        <input type='text' name='user_name'  placeholder='Write Your Full Name' required  />
                        <input type='email' name='user_email'  placeholder='Write Your Email' required/>
                        <textarea name='user_messager' placeholder='Write Your Messager' rows='7' required></textarea>
                            
                            
                            {!popup && (
                                <button className={classNames(styles.contact_button, )} type='submit'>
                                    Send a messager <FiArrowUpRight className={styles.i} style={{color: '#202020'}} />
                                </button>
                            )}

                            {popup && (
                                <>
                                    <div className={styles.success_checkmark}>
                                        <div className={styles.check_icon}>
                                            <span className={classNames(styles.icon_line, styles.line_tip)}></span>
                                            <span className={classNames(styles.icon_line, styles.line_long)}></span>
                                            <div className={styles.icon_circle}></div>
                                            <div className={styles.icon_fix}></div>
                                        </div>
                                    </div>
                                    <center>
                                        <h2> Sucess! your message was sent! </h2>
                                    </center>
                                </>
                                )}
                            
                        </form>
                    </div>
            </div>
            <SectionBorder />
        </section>
    )
}
